import * as React from "react";
import { handleLineBreaks } from "../helpers/prismicHelpers";
import "./fullCaseStudy.scss";
import { Cards } from "./cards";
import { AppContext } from "../layout/shell";
export var FullCaseStudy = function FullCaseStudy(_ref) {
  var data = _ref.data;

  var _React$useContext = React.useContext(AppContext),
      isMobile = _React$useContext.isMobile;

  var _React$useState = React.useState(true),
      isIntroExpanded = _React$useState[0],
      setIsIntroExpanded = _React$useState[1];

  var cards = {
    primary: {
      cards_per_row: 3,
      card_style: 'white-b',
      header: 'KEY METRICS'
    }
  };
  cards.fields = data.fields.map(function (f) {
    var c = {
      sub_header: f.key_metric_sub_header,
      header: f.key_metric_header,
      body_copy: f.key_metric_copy
    };
    return c;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "case-study full-case-study"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fixed-width"
  }, /*#__PURE__*/React.createElement("h4", null, handleLineBreaks(data.primary.sub_header)), /*#__PURE__*/React.createElement("h2", null, handleLineBreaks(data.primary.header)), /*#__PURE__*/React.createElement("h3", null, handleLineBreaks(data.primary.header_2)), isIntroExpanded && /*#__PURE__*/React.createElement("p", null, handleLineBreaks(data.primary.intro_copy)), isMobile && /*#__PURE__*/React.createElement("img", {
    src: data.primary.image["url"]
  }), /*#__PURE__*/React.createElement("div", {
    className: "case-study-body",
    style: {
      backgroundImage: !isMobile ? "url(" + data.primary.image["url"] + ")" : null
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "case-study-content"
  }, /*#__PURE__*/React.createElement("h3", null, handleLineBreaks(data.primary.quote)), /*#__PURE__*/React.createElement("p", null, handleLineBreaks(data.primary.quote_author)))), /*#__PURE__*/React.createElement(Cards, {
    data: cards
  }), /*#__PURE__*/React.createElement("div", {
    className: "partners"
  }, /*#__PURE__*/React.createElement("h2", null, "Partners"), /*#__PURE__*/React.createElement("div", {
    className: "partner-logos"
  }, /*#__PURE__*/React.createElement("img", {
    src: data.primary.partner_logo_1['url'],
    alt: data.primary.partner_logo_1['alt']
  }), /*#__PURE__*/React.createElement("img", {
    src: data.primary.partner_logo_2['url'],
    alt: data.primary.partner_logo_2['alt']
  }), /*#__PURE__*/React.createElement("img", {
    src: data.primary.partner_logo_3['url'],
    alt: data.primary.partner_logo_3['alt']
  }), /*#__PURE__*/React.createElement("img", {
    src: data.primary.partner_logo_4['url'],
    alt: data.primary.partner_logo_4['alt']
  })))));
};